// extracted by mini-css-extract-plugin
export default {"container":"BA5mZ2"};